import {useEffect, useState} from 'preact/hooks';
import {createCookie, getCookieValue} from '../utils/cookies';

export type Props = {
  cookieName: string;
  lifetime?: number | string;
  delay?: number;
};

export const useCookie = ({cookieName, lifetime = 30, delay = 2000}: Props) => {
  const [visible, setVisible] = useState(false);
  const [required, setRequired] = useState(false);
  const life = typeof lifetime === 'number' ? lifetime : parseInt(lifetime, 10);

  const saveCookie = () => {
    createCookie(cookieName, 'true', life);
    setRequired(false);
  };

  useEffect(() => {
    const accepted = getCookieValue(cookieName);

    if (accepted) {
      return;
    }

    setRequired(true);

    const timer = setTimeout(() => {
      setVisible(true);
    }, delay);

    return () => clearTimeout(timer);
  }, []);

  return {
    required,
    saveCookie,
    visible,
  };
};
